import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

interface SimpleAnimatedTextProps {
  text: string;
  className?: string;
}

const SimpleAnimatedText = ({ text, className = '' }: SimpleAnimatedTextProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current || !text) return;

    console.log('SimpleAnimatedText rendering:', text);

    const chars = text.split('');
    
    // Create spans with proper styling that works with gradient text
    containerRef.current.innerHTML = chars
      .map((char) => `<span class="inline-block" style="opacity: 0; transform: translateY(40px);">${char === ' ' ? '&nbsp;' : char}</span>`)
      .join('');

    const spans = containerRef.current.querySelectorAll('span');
    console.log('Found spans:', spans.length);

    // Animate each character with stagger
    gsap.to(spans, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      stagger: 0.1,
      ease: 'power3.out',
      delay: 0.1,
      onStart: () => console.log('Animation started'),
      onComplete: () => console.log('Animation completed'),
    });
  }, [text]);

  return (
    <h1 
      ref={containerRef} 
      className={className}
      style={{ minHeight: '100px', display: 'block' }}
    />
  );
};

export default SimpleAnimatedText;
